import ButtonWithProgress from "components/ButtonWithProgress";
import React, { useState } from "react";
import Modal from "react-responsive-modal";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useToasts } from "react-toast-notifications";
import WellnessService from "services/WellnessService";

const DeleteTrainingDocument = ({ onClose, documentId, setReload }) => {
  const params = useParams();
  const [submitting, setSubmitting] = useState(false);
  const { addToast } = useToasts();

  const deleteDocument = async () => {
    try {
      setSubmitting(true);
      await WellnessService.deleteTrainingDocument(params.teamId, documentId);
      setSubmitting(false);
      setReload(documentId);
      addToast("Document deleted successfully.", { appearance: "success" });
      onClose();
    } catch (e) {
      console.log(e);
      setSubmitting(false);
      addToast("An error occurred while deleting the document.", { appearance: "error" });
    }
  };

  return (
    <Modal
      closeOnEsc={false}
      closeOnOverlayClick={false}
      classNames={{ modalContainer: "modalContainer", modal: "listModal" }}
      open
      onClose={onClose}
    >
      <div className="p-4">
        <div className="shareVideoHeading">Are you sure?</div>
        <div className="shareVideoListContainer">
          <h5>You want to delete this document?</h5>
        </div>
        <div>
          <ButtonWithProgress
            initialText="Delete"
            message="Deleting"
            buttonWithProgressClass="grad_btn full_w h-50"
            onClick={deleteDocument}
            isSubmitting={submitting}
            type="button"
          />
        </div>
      </div>
    </Modal>
  );
};

export default DeleteTrainingDocument;
